import React from 'react';
import { Link, useParams } from 'react-router-dom';
import services from '../data/services';
import { useTranslation } from 'react-i18next';

const ServiceDetailsSec = ({ className = '' }) => {
    const { t } = useTranslation();
    const { slug } = useParams();
    const service = slug ? services.find((s) => s.slug === slug) : null;

    const detailsImage = service?.detailsImage || 'assets/img/service/service_single_1.jpg';
    const pageTitle = service?.translationKey 
        ? t('sections.ServiceCard.services.' + service.translationKey + '.title', service?.title || '')
        : t('sections.serviceDetailsSec.default_title','Cloud Security Posture Management');
    
    // Get categories from translation file
    const categories = t('sections.serviceDetailsSec.categories', { returnObjects: true }) || [
        'Cloud Security Management',
        'Cloud Workload Protection Platform',
        'Cloud Access Security Broker',
        'Cloud Security Management',
        'Endpoint Detection and Response'
    ];
    
    // Get FAQs from translation file
    const faqs = [
    {
        question: t('sections.serviceDetailsSec.faq1.question', 'Why do I need cybersecurity services?'),
        answer: t('sections.serviceDetailsSec.faq1.answer', 'We specialize in a wide range of software development services, including custom software development.')
    },
    {
        question: t('sections.serviceDetailsSec.faq2.question', "How does Secur's cybersecurity services work?"),
        answer: t('sections.serviceDetailsSec.faq2.answer', 'We specialize in a wide range of software development services, including custom software development.')
    },
    {
        question: t('sections.serviceDetailsSec.faq3.question', 'What is security consulting and compliance?'),
        answer: t('sections.serviceDetailsSec.faq3.answer', 'We specialize in a wide range of software development services, including custom software development.')
    },
    {
        question: t('sections.serviceDetailsSec.faq4.question', 'How does incident response work?'),
        answer: t('sections.serviceDetailsSec.faq4.answer', 'We specialize in a wide range of software development services, including custom software development.')
    },
    {
        question: t('sections.serviceDetailsSec.faq5.question', 'What is threat detection and response?'),
        answer: t('sections.serviceDetailsSec.faq5.answer', 'We specialize in a wide range of software development services, including custom software development.')
    }
    ];
    

    return (
    <>
      <section className={className}>
        <div className="bg-gradient-shape1" />
        <div className="bg-gradient-shape1 bg-gradient-shape2" />
        <div className="container">
            <div className="row">
            <div className="col-xxl-8 col-lg-7">
                <div className="page-single" data-cue="slideInUp">
                <div className="page-img mb-30">
                    <img
                        className="w-100"
                        src={detailsImage}
                        alt="Service Details"
                    />
                </div>
                <div className="page-content">
                    <h2 className="page-title mb-3">
                        {pageTitle}
                    </h2>
                    <p>
                    {t('sections.serviceDetailsSec.intro','Cloud Security Posture Management (CSPM) is a category of security solutions designed to enhance security of cloud environments by identifying and mitigating risks associated with cloud misconfigurations, compliance violations, and other vulnerabilities.')}
                    </p>
                    <h5 className="mt-35">{t('sections.serviceDetailsSec.benefits_heading','Service Benefits')}</h5>
                    <p className="mb-30">
                    {t('sections.serviceDetailsSec.benefits_text','By automating routine security tasks like compliance checks, misconfiguration detection, and risk prioritization, CSPM reduces workload on your IT and security teams, allowing them to focus on strategic initiatives.')}
                    </p>
                    <div className="row gy-4">
                    <div className="col-xl-6 col-lg-12 col-md-6">
                        <div className="service-info-card">
                        <div className="box-icon">
                            <img src="assets/img/service/service_inner1.svg" alt="service icon" />
                        </div>
                        <div className="box-content">
                            <h4 className="box-title">{t('sections.serviceDetailsSec.experienced_team_title','Experienced Team')}</h4>
                            <p className="box-text">
                            {t('sections.serviceDetailsSec.experienced_team_text','Our team is comprised of highly skilled professionals.')}
                            </p>
                        </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-12 col-md-6">
                        <div className="service-info-card">
                        <div className="box-icon">
                            <img src="assets/img/service/service_inner1.svg" alt="service icon" />
                        </div>
                        <div className="box-content">
                            <h4 className="box-title">{t('sections.serviceDetailsSec.support_title','24/7 Customer Support')}</h4>
                            <p className="box-text">
                            {t('sections.serviceDetailsSec.support_text','We offer 24/7 customer support, ensuring you have')}
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                    <h5 className="mt-40">{t('sections.serviceDetailsSec.importance_heading','The Importance of Cloud Security')}</h5>
                    <p className="mb-45">
                    {t('sections.serviceDetailsSec.importance_text','By automating routine security tasks like compliance checks, misconfiguration detection, and risk prioritization, CSPM reduces workload on your IT and security teams, allowing them to focus on strategic initiatives.')}
                    </p>
                    <div className="row gy-4">
                    <div className="col-md-6">
                        <div className="page-img">
                        <img
                            className="w-100"
                            src="assets/img/service/service_inner_2.jpg"
                            alt="Blog Service inner"
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="page-img">
                        <img
                            className="w-100"
                            src="assets/img/service/service_inner_3.jpg"
                            alt="Blog Service inner"
                        />
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="space-extra-top">
                <div className="title-area">
                    <span className="sub-title" data-cue="slideInUp">
                    {t('sections.serviceDetailsSec.faq_sub','Frequently Asked Questions')}
                    </span>
                    <h2 className="sec-title" data-cue="slideInUp">
                    {t('sections.serviceDetailsSec.faq_title','Quick Answers to Your Cyber Security Concerns')}
                    </h2>
                </div>
                <div
                    className="accordion mb-30"
                    id="faqAccordion"
                    data-cue="slideInUp"
                >
                  {faqs && Array.isArray(faqs) && faqs.map((f, i) => (
                    <div className="accordion-card style2" data-cue="slideInUp" key={i}>
                      <div className="accordion-header" id={`collapse-item-${i+1}`}>
                        <button
                          className={`accordion-button ${i !== 0 ? 'collapsed' : ''}`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${i+1}`}
                          aria-expanded={i === 0}
                          aria-controls={`collapse-${i+1}`}
                        >
                          {f.question}
                        </button>
                      </div>
                      <div
                        id={`collapse-${i+1}`}
                        className={`accordion-collapse collapse ${i === 0 ? 'show' : ''}`}
                        aria-labelledby={`collapse-item-${i+1}`}
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body">
                          <p className="faq-text">{f.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                </div>
            </div>
            <div className="col-xxl-4 col-lg-5 sidebar-wrap">
                <aside className="sidebar-area">
                <div className="widget widget_categories" data-cue="slideInUp">
                    <h3 className="widget_title">{t('sections.serviceDetailsSec.categories_title','Categories')}</h3>
                    <ul>
                        {categories && Array.isArray(categories) && categories.map((category, index) => (
                            <li key={index}>
                                <Link to="/blog">{category}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="widget widget_download  " data-cue="slideInUp">
                    <h4 className="widget_title">{t('sections.serviceDetailsSec.useful_documents_title','Useful Documents')}</h4>
                    <div className="download-widget-wrap">
                    <a href="#" className="icon-btn">
                        <i className="fa-regular fa-download" />
                    </a>
                    <div className="box-content">
                        <h4 className="box-title">{t('sections.serviceDetailsSec.company_info_title','Company Information')}</h4>
                        <p className="box-text">{t('sections.serviceDetailsSec.download_text','Download')}</p>
                    </div>
                    </div>
                </div>
                <div className="widget widget_contact_info  " data-cue="slideInUp">
                    <h3 className="widget_title">{t('sections.serviceDetailsSec.need_help_title','Need Any Help?')}</h3>
                    <p />
                    <div className="ot-widget-contact">
                    <div className="info-box">
                        <div className="box-icon">
                        <i className="far fa-map-marker-alt" />
                        </div>
                        <div className="media-body">
                        <h3 className="box-title">{t('sections.serviceDetailsSec.location_title','Location')}</h3>
                        <p className="box-text">
                            {t('sections.serviceDetailsSec.location_text','932 Dogwood Road,Chapel Hill,North Carolina')}
                        </p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="box-icon">
                        <i className="far fa-phone" />
                        </div>
                        <div className="media-body">
                        <h3 className="box-title">{t('sections.serviceDetailsSec.phone_title','Phone')}</h3>
                        <a className="box-link" href="tel:16555778749">
                            +165-5577-8749,
                        </a>
                        <a className="box-link" href="tel:16535647488">
                            +165-3564-7488
                        </a>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="box-icon">
                        <i className="far fa-envelope" />
                        </div>
                        <div className="media-body">
                        <h3 className="box-title">{t('sections.serviceDetailsSec.email_title','Email')}</h3>
                        <a className="box-link" href="mailto:enfo@secur2.com">
                            Enfo@secur.com,
                        </a>
                        <a className="box-link" href="mailto:enfo@secur2.com">
                            Enfo@secur2.com
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
                </aside>
            </div>
            </div>
        </div>
        </section>
 
    </>
  );
};

export default ServiceDetailsSec;
